import axios from 'axios'

import type { UserInfoResponse } from '@customTypes/user-api.type'
import { logger } from '@utils/logger'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

class UserService {
  private readonly path: string

  constructor() {
    this.path = apiBaseUrl
  }

  // Global User Feedback
  public async sendGlobalUserFeedback(feedback: string) {
    try {
      const url = `${this.path}/data_management/feedback`
      const result = await axios.post(url, {
        feedback: feedback,
      })
      return result.data
    } catch (err) {
      // console.log("Error, addUserFeedback:", err);
      throw err
    }
  }

  // Chat Feedback
  public async sendChatFeedback(chat_strid: string, user_rating: number) {
    try {
      const url = `${this.path}/data_management/chats/${chat_strid}/rating`
      const result = await axios.patch(url, {
        user_rating: user_rating,
      })
      return result.data
    } catch (err) {
      logger.log('Error, sendChatFeedback:', err)
      throw err
    }
  }

  // Get User Data
  public async getUserInfo(): Promise<UserInfoResponse> {
    try {
      const url = `${this.path}/data_management/users/self`
      const result = await axios.get<UserInfoResponse>(url)
      return result.data
    } catch (err) {
      logger.log('Error, getUserInfo:', err)
      throw err
    }
  }

  // Update User Data
  public async updateUserInfo(data: {
    email?: string
    password?: string
    name?: string
    position?: string
    company?: string
    language?: string
  }) {
    try {
      const url = `${this.path}/data_management/users/self`

      // Remove undefined fields from the payload
      const payload = Object.fromEntries(
        Object.entries(data).filter(([_, v]) => v !== undefined)
      )

      const result = await axios.patch(url, payload)
      return result.data
    } catch (err) {
      logger.log('Error, updateUserInfo:', err)
      throw err
    }
  }

  //get tenent info 
  public async getTenantInfo() {
    try {
      const url = `${this.path}/data_management/users/self/tenants`
      const result = await axios.get(url)
      return result.data
    } catch (err) {
      logger.log('Error, getTenantInfo:', err)
      throw err
    }
  }

  // Accept Terms And Conditions
  public async sendAcceptTermsAndConditions() {
    try {
      const url = `${this.path}/data_management/users/self/terms-and-conditions`
      const result = await axios.post(url)
      return result.data
    } catch (err) {
      console.error('Error, sendAcceptTermsAndConditions:', err)
      throw err
    }
  }

  // Delete User Account
  public async deleteUserAccount() {
    try {
      const url = `${this.path}/data_management/users/self`
      const result = await axios.delete(url)
      return result.data
    } catch (err) {
      logger.log('Error, deleteUserAccount:', err)
      throw err
    }
  }

  public async getUserHasPassword() {
    try {
      const url = `${this.path}/data_management/users/self/has_password`
      const result = await axios.get(url)
      return result.data
    } catch (err) {
      logger.log('Error, getUserHasPassword:', err)
      throw err
    }
  }

  public async isDeletable() {
    try {
      const url = `${this.path}/data_management/users/self/is_deletable`
      const result = await axios.get(url)
      return result.data
    } catch (err) {
      logger.log('Error, isDeletable:', err)
      throw err
    }
  }
}

export default UserService
